   // RB-MY01-PalmGarden.web/src/components/Notification.tsx
   import React, { useState, useEffect } from 'react';
   import { useApi, Notification } from '../services/api';
   import { 
     Badge, IconButton, Menu, MenuItem, 
     Typography, Box, Divider 
   } from '@mui/material';
   import NotificationsIcon from '@mui/icons-material/Notifications';
   
   const Notifications: React.FC = () => {
     const api = useApi();
     const [notifications, setNotifications] = useState<Notification[]>([]);
     const [loading, setLoading] = useState(false);
     const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
     const open = Boolean(anchorEl);
     
     useEffect(() => {
       const fetchNotifications = async () => {
         try {
           setLoading(true);
           const data = await api.getNotifications();
           setNotifications(data);
         } catch (err) {
           console.error('Error fetching notifications:', err);
         } finally {
           setLoading(false);
         }
       };
       
       fetchNotifications();
     }, [api]);
     
     const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
       setAnchorEl(event.currentTarget);
     };
     
     const handleClose = () => {
       setAnchorEl(null);
     };
     
     const handleMarkAsRead = async (id: number) => {
       try {
         await api.markNotificationAsRead(id);
         setNotifications(notifications.map(n => 
           n.id === id ? { ...n, read: true } : n
         ));
       } catch (err) {
         console.error('Error marking notification as read:', err);
       }
     };
     
     const unreadCount = notifications.filter(n => !n.read).length;
     
     return (
       <>
         <IconButton
           color="inherit"
           onClick={handleClick}
           aria-controls={open ? 'notifications-menu' : undefined}
           aria-haspopup="true"
           aria-expanded={open ? 'true' : undefined}
         >
           <Badge badgeContent={unreadCount} color="error">
             <NotificationsIcon />
           </Badge>
         </IconButton>
         
         <Menu
           id="notifications-menu"
           anchorEl={anchorEl}
           open={open}
           onClose={handleClose}
           MenuListProps={{
             'aria-labelledby': 'notifications-button',
           }}
           PaperProps={{
             style: {
               maxHeight: 400,
               width: '300px',
             },
           }}
         >
           <Typography variant="subtitle1" sx={{ px: 2, py: 1 }}>
             Notifications
           </Typography>
           <Divider />
           
           {loading ? (
             <MenuItem disabled>
               <Typography variant="body2">Loading notifications...</Typography>
             </MenuItem>
           ) : notifications.length === 0 ? (
             <MenuItem disabled>
               <Typography variant="body2">No notifications</Typography>
             </MenuItem>
           ) : (
             notifications.map((notification) => (
               <MenuItem 
                 key={notification.id}
                 onClick={() => {
                   handleMarkAsRead(notification.id);
                   handleClose();
                 }}
                 sx={{ 
                   bgcolor: notification.read ? 'inherit' : 'action.hover',
                   whiteSpace: 'normal'
                 }}
               >
                 <Box sx={{ width: '100%' }}>
                   <Typography variant="body2">{notification.message}</Typography>
                   <Typography variant="caption" color="text.secondary">
                     {new Date(notification.date).toLocaleString()}
                   </Typography>
                 </Box>
               </MenuItem>
             ))
           )}
         </Menu>
       </>
     );
   };
   
   export default Notifications;